import { useCallback, useMemo } from 'react'

import { useHasFixedPermissionAccess } from 'services/fixedpermissions'
import { useHasLicense } from 'services/security/license'
import { useHasModule } from 'services/security/modules'

const useSustainabilityMenu = (url) => {
  const [hasLicense, { loading: licenseLoading }] = useHasLicense()
  const [hasModule, { loading: moduleLoading }] = useHasModule()
  const [hasFixedPermission, { loading: fixedPermissionLoading }] = useHasFixedPermissionAccess()

  const allowed = hasLicense('medium') || hasLicense('enterprise')

  const hasSustFixedPerm = hasFixedPermission([
    'SUSTAINABILITY_VISITOR',
    'SUSTAINABILITY_CONTRIBUTOR',
    'SUSTAINABILITY_ADMINISTRATOR',
  ])

  const isModuleAllowed = useCallback(
    (key) => {
      return allowed && hasModule(key)
    },
    [allowed, hasModule]
  )

  const menuItems = useMemo(() => {
    const items = [
      {
        title: 'sustainability.menu.modules.ghg',
        key: 'config-modules',
        selectable: false,
        url: '',
        disabled: !isModuleAllowed('ghg') || !hasSustFixedPerm,
        children: [
          {
            title: 'sustainability.menu.config.research',
            key: 'config.research',
            url: `${url}/ghg/research`,
            disabled: !isModuleAllowed('ghg') || !hasSustFixedPerm,
          },
          {
            title: 'sustainability.menu.config.configuration-assistant',
            key: 'config.configuration-assistant',
            url: `${url}/ghg/configuration-assistant`,
            disabled: true,
          },
          {
            title: 'sustainability.menu.config.data-survey',
            key: 'config.data-survey',
            url: `${url}/ghg/data-survey`,
            disabled: true,
          },
          {
            title: 'sustainability.menu.config.validation',
            key: 'config.validation',
            url: `${url}/ghg/validation`,
            disabled: true,
          },
        ],
      },
      {
        title: 'sustainability.menu.csrd',
        key: 'csrd',
        selectable: false,
        url: '',
        disabled: true,
        children: [
          {
            title: 'sustainability.menu.csrd.research',
            key: 'csrd.research',
            url: '/csrd/research',
            disabled: true,
          },
          {
            title: 'sustainability.menu.csrd.doubleMateriality',
            key: 'csrd.doubleMateriality',
            url: '/csrd/double-materiality',
            disabled: true,
          },
          {
            title: 'sustainability.menu.csrd.configurationAssistant',
            key: 'csrd.configurationAssistant',
            url: '/csrd/configuration-assistant',
            disabled: true,
          },
          {
            title: 'sustainability.menu.csrd.dataSurvey',
            key: 'csrd.dataSurvey',
            url: '/csrd/data-survey',
            disabled: true,
          },
          {
            title: 'sustainability.menu.csrd.report',
            key: 'csrd.report',
            url: '/csrd/report',
            disabled: true,
          },
          {
            title: 'sustainability.menu.csrd.validation',
            key: 'csrd.validation',
            url: '/csrd/validation',
            disabled: true,
          },
        ],
      },
      {
        title: 'sustainability.menu.modules',
        key: 'sustainability-modules',
        selectable: false,
        url: `${url}`,
        disabled: !allowed,
        children: [
          {
            title: 'sustainability.menu.modules.csrd',
            key: 'modules.csrd',
            url: `${url}/module/csrd`,
            disabled: !isModuleAllowed('csrd') || !hasSustFixedPerm,
          },
          {
            title: 'sustainability.menu.modules.esg',
            key: 'modules.esg',
            url: `${url}/module/esg`,
            disabled: !isModuleAllowed('esg') || !hasSustFixedPerm,
          },
          {
            title: 'sustainability.menu.modules.ghg',
            key: 'modules.ghg',
            url: `${url}/module/greenhouse-gas-protocol`,
            disabled: !isModuleAllowed('ghg') || !hasSustFixedPerm,
          },
          {
            title: 'sustainability.menu.modules.gri',
            key: 'modules.gri',
            url: `${url}/module/gri`,
            disabled: !isModuleAllowed('gri') || !hasSustFixedPerm,
          },
          {
            title: 'sustainability.menu.modules.sbti',
            key: 'modules.sbti',
            url: `${url}/module/sbti`,
            disabled: !isModuleAllowed('sbti') || !hasSustFixedPerm,
          },
          {
            title: 'sustainability.menu.modules.sdg',
            key: 'modules.sdg',
            url: `${url}/module/sdg`,
            disabled: !isModuleAllowed('sdg') || !hasSustFixedPerm,
          },
        ],
      },
    ]

    return items
  }, [isModuleAllowed, allowed, url, hasSustFixedPerm])

  return [menuItems, { loading: licenseLoading || moduleLoading || fixedPermissionLoading }]
}

export default useSustainabilityMenu
